'use client';

import { useRef } from 'react';

import { Destination } from '../../../../resources/destination/domain/types/destination';
import { HomePageDocument } from '../../../../resources/homePageDocument/domain/types/homePageDocument';
import { UgcHighlight } from '../../../../resources/ugcHighlight/domain/types/ugcHighlight';
import { useTrackBlockViewed } from '../../../../shared/hooks/useTrackBlockViewed';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';

import { InfluencersUgcCarousel } from './InfluencersUgc/Carousel/InfluencersUgcCarousel';
import { InfluencersUgcSectionTitle } from './InfluencersUgc/Title/InfluencersUgcSectionTitle';
import { UgcSectionTitle } from './Title/UgcSectionTitle';
import { TravelersUgcCarousel } from './TravelersUgc/Carousel/TravelersUgcCarousel';
import { TravelersUgcSectionTitle } from './TravelersUgc/Title/TravelersUgcSectionTitle';
import style from './UgcSection.module.css';

type UgcSectionProps = {
    travelersUgc: Array<
        PickDomain<
            UgcHighlight,
            'id' | 'segment' | 'username' | 'description' | 'pictures',
            {
                destination: PickDomain<Destination, 'id' | 'name' | 'slug' | 'preposition'>;
            }
        >
    >;
    influencersUgc: HomePageDocument['influencersUgc'];
};

export function UgcSection({ travelersUgc, influencersUgc }: UgcSectionProps) {
    const hasTravelersUgc = travelersUgc.length > 0;
    const hasInfluencersUgc = influencersUgc.length > 0;
    const travelersUgcRef = useRef<HTMLDivElement>(null);
    const influencersUgcRef = useRef<HTMLDivElement>(null);

    useTrackBlockViewed(travelersUgcRef, 'ugc');
    useTrackBlockViewed(influencersUgcRef, 'social');

    return (
        <section className={style.section}>
            <div className="layout-with-centered-content">
                <div className="main-container">
                    <UgcSectionTitle />
                </div>
            </div>

            {hasTravelersUgc ? (
                <div ref={travelersUgcRef}>
                    <div className="layout-with-centered-content">
                        <div className="main-container">
                            <TravelersUgcSectionTitle />
                        </div>
                    </div>
                    <TravelersUgcCarousel travelersUgc={travelersUgc} />
                </div>
            ) : null}

            {hasInfluencersUgc ? (
                <div ref={influencersUgcRef}>
                    <div className="layout-with-centered-content">
                        <div className="main-container">
                            <InfluencersUgcSectionTitle />
                        </div>
                    </div>
                    <InfluencersUgcCarousel influencersUgc={influencersUgc} />
                </div>
            ) : null}
        </section>
    );
}
